//PAQUETERIAS
import React, { useEffect, useState, useMemo } from "react";
import { MaterialReactTable } from 'material-react-table';

//COMPONENTES
import { detail_invoice_get } from "../../../../services/invoices/invoices";
//ESTILOS
import "../../../estilo.css";
import "../../../modal.css";
import "../../../table.css";
import { refresh_token } from "../../../../main_components/tokens/tokenrefresh";
import "./detail_invoice.css";


function DETAIL_INVOICE_V2(props) {
  const [data, setData] = useState([]);
  const handle_get_invoice_detail = async (event) => {
    event?.preventDefault();
    setData([]);
  
    try {

      const { id, c_tipodecomprobante } = props.row;
      
      const response = await detail_invoice_get(id, {c_tipodecomprobante});
      setData(response?.data?.details ?? response?.data ?? []);
      
      console.log(response?.data);
    } catch (err) {
      console.error("Error fetching invoice details:", err);
      setData([]);
    }
  };
  

  useEffect(() => {
    handle_get_invoice_detail();
  }, [props.reconsult]);

  const columnsp = useMemo(
    () => [
      {
        header: "Folio Factura",
        accessorKey: "folio"
      },
      {
        header: "UUID Factura",
        accessorKey: "uuid"
      },
      {
        header: "Monto",
        accessorFn: (d) => {
          return d.monto
            ? Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.monto)
            : Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.monto);
        },

      },
      {
        header: "Base IEPS",
        accessorFn: (d) => {
          return d.baseIEPS8
            ? Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.baseIEPS8)
            : Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.baseIEPS8);
        },
      },
      {
        header: "Base Iva",
        accessorFn: (d) => {
          return d.baseIVA0
            ? Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.baseIVA0)
            : Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.baseIVA0);
        },
      }
    ], []
  )

  const columns = useMemo(
    () => [
      {
        header: "Cantidad",
        accessorKey: "quantity",
      },
      {
        header: "Unidad",
        accessorKey: "unity",
      },
      {
        header: "Descripción",
        accessorKey: "description",
      },
      {
        header: "Descuento",
        accessorFn: (d) => {
          return d.discount
            ? Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.discount)
            : Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.discount);
        },
      },
      {
        header: "Precio Unitario",
        accessorFn: (d) => {
          return d.unitary_price
            ? Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.unitary_price)
            : Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.unitary_price);
        },
      },

      {
        header: "Total",
        accessorFn: (d) => {
          return d.total
            ? Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.total)
            : Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(d.total);
        },
      },
    ],
    []
  );

  return <MaterialReactTable
    columns={props.row.c_tipodecomprobante === "P" ? columnsp : columns}
    data={data}
    enableColumnActions={false}
    enableColumnFilters
    enablePagination
    enableSorting
    enableBottomToolbar={false}
    enableTopToolbar={false}
    muiTableBodyRowProps={{ hover: false }}
  />;
}

export default DETAIL_INVOICE_V2;
